import React, { CSSProperties, FC } from "react";
import LoadingError from "./ui/LoadingError";
import { ApolloError } from "@apollo/client";
import Spinner from "@src/lib/ui/Spinner";

type Props = {
  loading: boolean;
  error?: ApolloError;
  loadingState?: React.ReactElement;
  errorState?: React.ReactElement;
  loadingContainerStyle?: CSSProperties;
  loaderVisibilityDelayMs?: number;
};

const QueryStatus: FC<Props> = ({
  loading,
  error,
  loadingState,
  errorState,
  loadingContainerStyle,
  loaderVisibilityDelayMs = 300,
}) => {
  if (error) {
    return (
      <div className="flex size-full items-center justify-center">
        {errorState || <LoadingError error={error} />}
      </div>
    );
  } else if (loading) {
    return (
      <div
        style={loadingContainerStyle}
        className="flex flex-1 items-center justify-center"
      >
        {loadingState || (
          <Spinner size={60} visibilityDelayMs={loaderVisibilityDelayMs} />
        )}
      </div>
    );
  } else {
    return null;
  }
};

export default QueryStatus;
